import { useQuery } from '@tanstack/react-query'
import { fetchWithAuth } from '@/data/api/client'
import type {
  BreakdownTableRequest,
  BreakdownTableResponse,
  BreakdownTimeSeriesRequest,
  BreakdownTimeSeriesResponse,
  BreakdownTrendsRequest,
  BreakdownTrendsResponse,
} from '@/data/types/breakdown.types'

async function getBreakdownTable(request: BreakdownTableRequest): Promise<BreakdownTableResponse> {
  return fetchWithAuth('/api/v1/breakdown/table', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

async function getBreakdownTimeSeries(
  request: BreakdownTimeSeriesRequest
): Promise<BreakdownTimeSeriesResponse> {
  return fetchWithAuth('/api/v1/breakdown/timeseries', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

export function useBreakdownTable(request: BreakdownTableRequest | null, enabled: boolean = true) {
  return useQuery({
    queryKey: ['breakdownTable', request],
    queryFn: () => getBreakdownTable(request!),
    enabled: enabled && request !== null,
  })
}

export function useBreakdownTimeSeries(
  request: BreakdownTimeSeriesRequest | null,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['breakdownTimeSeries', request],
    queryFn: () => getBreakdownTimeSeries(request!),
    enabled: enabled && request !== null,
  })
}

async function getBreakdownTrends(
  request: BreakdownTrendsRequest
): Promise<BreakdownTrendsResponse> {
  return fetchWithAuth('/api/v1/breakdown/trends', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

export function useBreakdownTrends(
  request: BreakdownTrendsRequest | null,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['breakdownTrends', request],
    queryFn: () => getBreakdownTrends(request!),
    enabled: enabled && request !== null,
  })
}

